// ShipListTable.tsx
import React from 'react';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  ScrollArea,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@ais-ui/ui-core';
import { DetailedShipList } from '@ais-ui/api-spec/config';
import { useLocalization } from '@ais-ui/locale-management';

interface ShipListTableProps {
  detailedShiplist: DetailedShipList;
  showPopover: boolean;
  setShowPopover: (showPopover: boolean) => void;
}

export const ShipListTable = ({
  detailedShiplist,
  showPopover,
  setShowPopover,
}: ShipListTableProps) => {
  const { messages } = useLocalization();

  return (
    <Popover open={showPopover}>
      <PopoverTrigger asChild>
        <div></div>
      </PopoverTrigger>
      <PopoverContent className="w-full" side="left" align="start">
        <div className="flex justify-between">
          <div className="text-md font-medium pb-2">Ships</div>
          <Button
            variant="ghost"
            size="icon"
            className="-mt-3 -mr-3"
            onClick={() => setShowPopover(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
              className="h-4 w-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </Button>
        </div>
        <ScrollArea className="h-72 w-full py-2 overflow-auto pl-2 pr-4">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{messages.shiplistsTableIndexHeader}</TableHead>
                <TableHead>{messages.shiplistsTableNameHeader}</TableHead>
                <TableHead className="text-right">
                  {messages.shiplistsTableMMSIHeader}
                </TableHead>
                <TableHead className="text-right">
                  {messages.shiplistsTableIMOHeader}
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {detailedShiplist?.ships?.map((ship, index) => (
                <TableRow key={ship.imo || index}>
                  <TableCell className="font-medium">{index + 1}</TableCell>
                  <TableCell>{ship.name}</TableCell>
                  <TableCell className="text-right">{ship.mmsi}</TableCell>
                  <TableCell className="text-right">{ship.imo}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
};
